module.exports = __webpack_public_path__ + "static/media/customDesignPhoto2.304de800.PNG";